import React, { Component } from "react";

import classNames from "classnames";
import { string, oneOf, bool } from "prop-types";

import * as utils from "util/general";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";

class TransactionStatus extends Component {
    static propTypes = {
        idTransactionStatus: string.isRequired,
        iconFidelity: oneOf(["list", "transaction", "ticket"]),
        showLabel: bool,
        showIcon: bool,
        className: string,
    };

    static defaultProps = {
        iconFidelity: "transaction",
        showLabel: false,
        showIcon: true,
        className: "",
    };

    getImagePath = () => {
        const { idTransactionStatus } = this.props;

        let icon = "";
        if (idTransactionStatus === "FAILED" || idTransactionStatus === "CANCELLED") {
            icon = "icon/error";
        } else if (
            idTransactionStatus === "RUNNING" ||
            idTransactionStatus === "RETURNED" ||
            idTransactionStatus === "PENDING" ||
            idTransactionStatus === "PROCESSING" ||
            idTransactionStatus === "AWAITING" ||
            idTransactionStatus === "DRAFT"
        ) {
            icon = "icon/transacciones-pendientes";
        } else if (idTransactionStatus === "FINISHED" || idTransactionStatus === "SCHEDULED") {
            icon = "icon/success";
        }
        return icon;
    };

    render() {
        const { idTransactionStatus, iconFidelity, showIcon, showLabel, className } = this.props;

        const image =
            iconFidelity === "list"
                ? this.getImagePath()
                : `illustrations/ticket-${utils.getTransactionStatusIcon(idTransactionStatus)}`;

        return (
            <div className={`bubble-wrapper ${className}`}>
                <div
                    className={classNames("text-label", {
                        " danger-label": idTransactionStatus === "FAILED" || idTransactionStatus === "CANCELLED",
                        " warning-label":
                            idTransactionStatus === "RUNNING" ||
                            idTransactionStatus === "RETURNED" ||
                            idTransactionStatus === "PENDING" ||
                            idTransactionStatus === "PROCESSING" ||
                            idTransactionStatus === "AWAITING" ||
                            idTransactionStatus === "DRAFT",
                        " success-label": idTransactionStatus === "FINISHED" || idTransactionStatus === "SCHEDULED",
                    })}>
                    {showIcon && (
                        <Image
                            src={`images/figma/${image}.svg`}
                            className={classNames("svg-icon", {
                                "ticket-header-illustration": iconFidelity === "ticket",
                            })}
                        />
                    )}

                    {showLabel && <I18n id={`transaction.status.${idTransactionStatus}`} />}
                </div>
            </div>
        );
    }
}

export default TransactionStatus;
